export enum FulfillmentStepDisplayStatusGroupType {
  total = "Total",
  pending = "Pending",
  assigned = "Assigned",
  pickupInProgress = "PickupInProgress",
  destinationInProgress = "DestinationInProgress",
  problem = "Problem",
  completed = "Completed",
  onHold = "OnHold",
  canceled = "Canceled",
}
